import request from '@/utils/request'

let IndexApi = {
  /*基础配置*/
  baseinfo(data, errorback) {
    return request._post('/pc/homepage/homeInfo', data, errorback);
  },
  /*商城首页*/
  culturelist(data, errorback) {
    return request._post('/pc/homepage/cultureInfo', data, errorback);
  },
  /*轮播图*/
  banner(data, errorback) {
    return request._post('/pc/carousel/carouselList', data, errorback);
  },
  /*医院公告*/
  notice(data, errorback) {
    return request._post('/pc/notice/noticePage', data, errorback);
  },
  /*医院公告*/
  noticeDetail(data, errorback) {
    return request._post('/pc/notice/noticeInfo', data, errorback);
  },
  /*医院公告--年份*/
  noticeYear(data, errorback) {
    return request._post('/pc/notice/noticeYearList', data, errorback);
  },
  /*重大新闻*/
  news(data, errorback) {
    return request._post('/pc/news/newsPage', data, errorback);
  },
  /*重大新闻*/
  newsDetail(data, errorback) {
    return request._post('/pc/news/newsInfo', data, errorback);
  },
  /*重大新闻--年份*/
  newsYear(data, errorback) {
    return request._post('/pc/news/newsYearList', data, errorback);
  },
  /*信息公告*/
  message(data, errorback) {
    return request._post('/pc/message/messagePage', data, errorback);
  },
  /*科室介绍*/
  department(data, errorback) {
    return request._post('/pc/room/roomList', data, errorback);
  },
  /*健康资讯*/
  informationlist(data, errorback) {
    return request._post('/pc/health/healthPage', data, errorback);
  },
  /*健康资讯详情*/
  informationdetail(data, errorback) {
    return request._post('/pc/health/healthInfo', data, errorback);
  },
  /*科室列表*/
  departmentlist(data, errorback) {
    return request._post('/pc/room/roomList', data, errorback);
  },
  /*科室详情*/
  departmentdetail(data, errorback) {
    return request._post('/pc/room/roomInfo', data, errorback);
  },
  /*信息公告*/
  messagelist(data, errorback) {
    return request._post('/pc/message/messagePage', data, errorback);
  },
  /*信息公告详情*/
  messagedetail(data, errorback) {
    return request._post('/pc/message/messageInfo', data, errorback);
  },
}

export default IndexApi;



// WEBPACK FOOTER //
// ./src/api/index.js